import { useAIAutoReply } from '@debbie/cortex/dist/ai/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import AI from '../AI.js';
import Badge from '../Badge.js';
import Loading from '../Loading.js';
import ProgressBar from '../ProgressBar.js';
const AIGeneratedIndicator = (props) => {
    const lang = useSelector((s) => s.lang);
    const [showTooltip, setShowTooltip] = useState(false);
    return (React.createElement(Wrapper, { onMouseEnter: () => setShowTooltip(true), onMouseLeave: () => setShowTooltip(false) },
        React.createElement(AI, { height: "1em" }),
        React.createElement("span", null, lang.interactions.aiGenerated),
        showTooltip && props.aiAutoReplyId && (React.createElement(AIInfoTooltip, { aiAutoReplyId: props.aiAutoReplyId }))));
};
const AIInfoTooltip = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const autoReplySettings = tenant?.settings?.ai?.autoReply;
    const aiAutoReplyLoader = useAIAutoReply(props.aiAutoReplyId);
    const aiInfo = h.hasData(aiAutoReplyLoader) ? aiAutoReplyLoader.data : null;
    if (h.isLoading(aiAutoReplyLoader)) {
        return (React.createElement(Tooltip, null,
            React.createElement(Loading, { width: "1.5em" })));
    }
    if (aiInfo == null) {
        return (React.createElement(Tooltip, null,
            React.createElement("span", null,
                lang.ai.qualityScore,
                ": -")));
    }
    return (React.createElement(Tooltip, null,
        React.createElement(ScoreRow, null,
            React.createElement(ScoreLabel, null, lang.ai.qualityScore),
            aiInfo.qualityScore != null ? (React.createElement(ProgressBar, { value: aiInfo.qualityScore })) : (React.createElement("span", null, "-"))),
        React.createElement(ScoreRow, null,
            React.createElement(ScoreLabel, null, lang.ai.safetyScore),
            aiInfo.safetyScore != null ? (React.createElement(ProgressBar, { value: aiInfo.safetyScore })) : (React.createElement("span", null, "-"))),
        aiInfo.manipulationDetected && (React.createElement(ManipulationWarning, null, lang.ai.manipulationDetected)),
        aiInfo.sensitivityFlags.length > 0 && (React.createElement(FlagsContainer, null, aiInfo.sensitivityFlags.map((flag, i) => (React.createElement(Badge, { key: i, theme: THEME.DANGEROUS }, flag))))),
        React.createElement("p", null, aiInfo.judgeReasoning)));
};
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding: 8px 15px;
  background: ${THEME.BACKGROUND};
  border-bottom: 1px solid lightgrey;
  font-size: 0.85em;
  color: ${THEME.COLOR_PRIMARY};
  position: relative;
  cursor: default;
  border: 1px solid lightgray;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
`;
const Tooltip = styled.div `
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid lightgrey;
  border-radius: 4px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 100;
  font-size: 0.9em;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const ScoreRow = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
`;
const ScoreLabel = styled.span `
  font-weight: 600;
  min-width: 90px;
`;
const ManipulationWarning = styled.div `
  color: ${THEME.DANGEROUS};
  font-weight: 600;
`;
const FlagsContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;
export default AIGeneratedIndicator;
//# sourceMappingURL=AIGeneratedIndicator.js.map